import { useDealership } from '../../../store/zustand/dealershipStore'
import { useQuery, useQueryClient, UseQueryResult } from 'react-query'
import type { ClickHouseCustomer } from '@demandlocal/utils/lib/clickhouse/models/Customers'
import type { ClickHouseCustomerEvent } from '@demandlocal/utils/lib/clickhouse/models/CustomerEvents'
import request from '../../request'
import { Pagination } from '../../../lib/types/Pagination'
import { ParsedClickHouseCustomer } from '../../../types/Customer'
import { ParsedClickHouseCustomerEvent } from '../../../types/CustomerEvent'

type ParsedCustomerWithEvents = ParsedClickHouseCustomer & {
  events: ParsedClickHouseCustomerEvent<any>[]
}

export const useGetCustomerByID = (
  customerId: string | undefined,
): UseQueryResult<ParsedCustomerWithEvents> => {
  const dealership = useDealership()
  const queryClient = useQueryClient()

  return useQuery(
    ['customer', dealership?.id, customerId],
    async ({ signal }) => {
      const response = await request<{ data: ParsedCustomerWithEvents }>({
        url: `/agencies/${dealership?.organization_id}/dealership/${dealership?.id}/customers/customer/${customerId}`,
        method: 'GET',
        signal,
      }).then((res) => res.data)
      return response
    },
    {
      enabled: !!dealership?.id && !!customerId,
      staleTime: 5 * 60 * 1000, // Consider data fresh for 5 minutes
      placeholderData: () => {
        // Try to find the customer in the cached customers list
        const customerQueries = queryClient.getQueriesData<{
          data: ParsedCustomerWithEvents[]
          pagination: Pagination
        }>(['dealership', dealership?.id, 'customers'])

        for (const [, queryData] of customerQueries) {
          if (queryData && queryData.data) {
            const foundCustomer = queryData.data.find(
              (customer) => customer.id === customerId,
            )
            console.log(foundCustomer)
            if (foundCustomer) return foundCustomer
          }
        }

        return undefined
        //return customers?.data.find((customer) => customer._id.toString() === customerId)
      },
    },
  )
}
